
import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout';
import { getCurrentUser } from '../../services/cognito';
import { healthService } from '../../services/api';

export default function FreeTrial() {
    const [user, setUser] = useState<any>(null);
    const [systemStatus, setSystemStatus] = useState<'online' | 'offline' | 'warning'>('online');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            try {
                // 1. Get User Attributes
                const cognitoUser = getCurrentUser();
                if (cognitoUser) {
                    cognitoUser.getSession((err: any, session: any) => {
                        if (!err) {
                            cognitoUser.getUserAttributes((err, attributes) => {
                                if (!err && attributes) {
                                    const userAttrs: any = {};
                                    attributes.forEach(attr => {
                                        userAttrs[attr.getName()] = attr.getValue();
                                    });
                                    setUser(userAttrs);
                                }
                            });
                        }
                    });
                }

                // 2. Check System Health
                try {
                    // We use Promise.allSettled so one failure doesn't block the rest
                    const results = await Promise.allSettled([
                        healthService.checkGDPRHealth(),
                        healthService.checkLandlordHealth(),
                        healthService.checkFoodSafetyHealth()
                    ]);

                    const hasFailure = results.some(r => r.status === 'rejected');
                    if (hasFailure) {
                        setSystemStatus('warning');
                    } else {
                        setSystemStatus('online');
                    }
                } catch (e) {
                    console.error('Health check failed', e);
                    setSystemStatus('offline');
                }

            } catch (error) {
                console.error('Error loading dashboard data', error);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, []);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f8fafc' }}>
                <div>Loading Dashboard...</div>
            </div>
        );
    }

    return (
        <DashboardLayout user={user} systemStatus={systemStatus}>
            <Routes>
                <Route path="/" element={<DashboardHome user={user} />} />
                {/* Placeholder routes for future implementation */}
                <Route path="/gdpr" element={<div>GDPR Compliance Module (Coming Soon)</div>} />
                <Route path="/landlord" element={<div>Property Manager Module (Coming Soon)</div>} />
                <Route path="/food-safety" element={<div>Food Safety Module (Coming Soon)</div>} />
                <Route path="/settings" element={<div>Settings (Coming Soon)</div>} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </DashboardLayout>
    );
}

// Simple Home Component for the Dashboard
const DashboardHome = ({ user }: { user: any }) => (
    <div>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 600, color: '#1e293b', marginBottom: '1rem' }}>
            Welcome back, {user?.given_name || 'User'}
        </h1>
        <div style={{
            background: 'white',
            padding: '2rem',
            borderRadius: '0.5rem',
            border: '1px solid #e2e8f0',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
        }}>
            <p style={{ color: '#64748b' }}>
                Select a module from the sidebar to manage your compliance requirements.
            </p>
        </div>
    </div>
);
